"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkSwitcher = void 0;
const connectors_1 = require("@utils/connectors");
const core_1 = require("@web3-react/core");
const react_1 = __importDefault(require("react"));
const logo_1 = require("@shared-modules/components/logo");
const button_1 = require("@shared-modules/components/button");
require("./styles.scss");
const translation_hooks_1 = require("@hooks/translation.hooks");
const NETWORK_CONFIGS = [
    {
        id: 56,
        name: "Binance Smart Chain",
        config: [
            {
                chainId: "0x38",
                // chainName: "Binance Smart Chain",
                // nativeCurrency: {
                //   name: "BNB",
                //   symbol: "BNB",
                //   decimals: 18,
                // },
                // rpcUrls: ["https://bsc-dataseed.binance.org/"],
                // blockExplorerUrls: ["https://bscscan.com/"],
            },
        ],
    },
    {
        id: 97,
        name: "Binance Smart Chain Test",
        config: [
            {
                chainId: "0x61",
                // chainName: "Binance Smart Chain Test",
                // nativeCurrency: {
                //   name: "BNB",
                //   symbol: "BNB",
                //   decimals: 18,
                // },
                // rpcUrls: ["https://data-seed-prebsc-1-s1.binance.org:8545/"],
                // blockExplorerUrls: ["https://bscscan.com/"],
            },
        ],
    },
];
const NetworkSwitcher = (props) => {
    const { supportedChainIds } = props;
    const context = (0, core_1.useWeb3React)();
    const translator = (0, translation_hooks_1.useComponentTranslation)("networkSwitcher");
    const changeNetwork = (id) => {
        if (context.connector === connectors_1.injected) {
            const network = NETWORK_CONFIGS.find(({ id: chainId }) => chainId === id);
            if (network) {
                window.ethereum.request({ method: "wallet_switchEthereumChain", params: network.config }).catch();
            }
        }
    };
    const chainList = NETWORK_CONFIGS.filter(({ id }) => supportedChainIds.some((chainId) => chainId === id));
    return (react_1.default.createElement("div", { className: "c-network-switcher" },
        react_1.default.createElement("div", { className: "c-network-switcher__logo" },
            react_1.default.createElement(logo_1.Logo, { scale: 1.5 })),
        react_1.default.createElement("div", { className: "c-network-switcher__title" }, translator("title")),
        react_1.default.createElement("div", { className: "c-network-switcher__switcher" }, chainList.map(({ id, name }) => (react_1.default.createElement(button_1.Button, { key: id, onClick: () => changeNetwork(id) }, name))))));
};
exports.NetworkSwitcher = NetworkSwitcher;
